import { Pipe, PipeTransform } from '@angular/core';
import {User} from '@app/models/vcr-entity/user';
import {LocalUser} from '@app/state/local-user.state';
import {RemoteParticipantInfo} from '@app/models/remote-participant-info';
import {RemoteUserAdditionalInfoStateModel} from '@app/state/remote-users.state';
import {AccessType} from '@app/modules/shared/data/constants';

@Pipe({
  name: 'isSupport'
})
export class IsSupportPipe implements PipeTransform {
  public transform(user: User | LocalUser | RemoteParticipantInfo | RemoteUserAdditionalInfoStateModel): boolean {
    return user.accessType === AccessType.SUPPORT;
  }
}
